import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { SavePostLike } from "../../apis/posts/save_post_like";
import { SavePostShare } from "../../apis/posts/save_post_share";
import { PostLikeNoteApi } from "../../apis/notification/post_like_note";
import { FacebookIcon, WhatsappIcon, EmailIcon, TwitterIcon, TelegramIcon, InstapaperIcon, LinkedinIcon, XIcon, FacebookMessengerIcon, PinterestIcon } from "react-share";
import { FacebookShareButton, WhatsappShareButton, EmailShareButton, LinkedinShareButton, TwitterShareButton, TelegramShareButton, InstapaperShareButton, FacebookMessengerShareButton, PinterestShareButton } from "react-share";
import { RemovePostLike } from "../../apis/posts/remove_post_like";

export default function PostBoxFooter({ item, showLike, showShare }) {
    const [likeCount, setLikeCount] = useState(0);
    const [shareCount, setShareCount] = useState(0);
    const [viewCount, setViewCount] = useState(0);
    const [enroled, setEnroled] = useState(0);
    const [enrolApi, setEnrolApi] = useState(API_STATUS);
    const [saveStatus, setSaveStatus] = useState(API_STATUS);
    const [userLike, setUserLike] = useState(false);
    const [shareUrl, setShareUrl] = useState('https://website.filmwings.com/post_id/' + item.post_id);
    const [shareTitle, setShareTitle] = useState(item.title);
    const [shareBox, setShareBox] = useState(false);

    useEffect(() => {
        if (item.userLike != "0") {
            setUserLike(true);
        } else {
            setUserLike(false);
        }
        setLikeCount(item.likeCount);
        setShareCount(item.shareCount);
        setViewCount(item.viewCount);
    }, []);

    const _saveLike = () => {
        const code = sessionStorage.getItem('USER_CODE');
        setUserLike(true);
        setLikeCount(likeCount + 1);

        const body = {
            "postId": item.p_id,
            "ip": "",
            "device": "Web"
        };
        SavePostLike(body, setSaveStatus);

        const nbody = { "pid": item.p_id, "mfrom": code };
        PostLikeNoteApi(nbody);

    }

    const _removeLike = () => {
        setUserLike(false);
        setLikeCount(likeCount - 1);
        RemovePostLike(item.p_id, setSaveStatus);
    }

    const _saveShare = () => {
        setShareCount(shareCount + 1);
        SavePostShare(item.p_id, setSaveStatus);
    }

    return <div>
        <div className="sm:p-4 p-2.5 flex items-center gap-4 text-xs font-semibold">
            <div className="flex items-center gap-2.5">
                {
                    userLike &&
                    <button
                        onClick={_removeLike}
                        type="button" className="button__ico text-red-500 bg-red-100 dark:bg-slate-700">
                        <ion-icon className="text-lg" name="heart"><i className="fa fa-heart"></i></ion-icon>
                    </button>
                }
                {
                    !userLike &&
                    <button
                        onClick={_saveLike}
                        type="button" className="button__ico bg-slate-200/70 dark:bg-slate-700">
                        <ion-icon className="text-lg" name="heart"><i className="fa fa-heart"></i></ion-icon>
                    </button>
                }
                {
                    likeCount > 0 && showLike === 1 && <span>{likeCount}</span>
                }
            </div>
            <div className="flex items-center gap-3">
                <button type="button" className="button__ico bg-slate-200/70 dark:bg-slate-700">
                    <ion-icon className="text-lg" name="chatbubble-ellipses">
                        <i className="fa fa-eye"></i>
                    </ion-icon> </button>
                {
                    viewCount > 0 && <span>{viewCount}</span>
                }
            </div>
            <div className="flex items-center gap-3">
                <button
                    onClick={() => setShareBox(!shareBox)}
                    type="button" className="button__ico">
                    <ion-icon className="text-xl" name="share-outline">
                        <i className="fa fa-share"></i>
                    </ion-icon> </button>
                {
                    shareCount > 0 && showShare === 1 && <span>{shareCount}</span>
                }
            </div>



            {/* <button type="button" className="button__ico ml-auto">
            <ion-icon className="text-xl" name="paper-plane-outline">
                <i className="fa fa-send-o"></i>
            </ion-icon> </button> */}

        </div>
        {
            shareBox &&

            <div style={{ paddingLeft: 10 }}>
                <p>Share on</p>
                <div>
                    <FacebookShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <FacebookIcon round={true} size={30} />
                    </FacebookShareButton>

                    <FacebookMessengerShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <FacebookMessengerIcon round={true} size={30} />
                    </FacebookMessengerShareButton>

                    <WhatsappShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <WhatsappIcon round={true} size={30} />
                    </WhatsappShareButton>

                    <EmailShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <EmailIcon round={true} size={30} />
                    </EmailShareButton>

                    <LinkedinShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <LinkedinIcon round={true} size={30} />
                    </LinkedinShareButton>

                    <TwitterShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <XIcon round={true} size={30} />
                    </TwitterShareButton>

                    <TelegramShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <TelegramIcon round={true} size={30} />
                    </TelegramShareButton>

                    <InstapaperShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <InstapaperIcon round={true} size={30} />
                    </InstapaperShareButton>

                    <PinterestShareButton
                        url={shareUrl}
                        title={shareTitle}
                        onShareWindowClose={_saveShare}
                        style={{ marginRight: 5 }}>
                        <PinterestIcon round={true} size={30} />
                    </PinterestShareButton>
                </div>
            </div>
        }
    </div>
}